import React, { useState } from "react";
import { Button, Container } from "react-bootstrap";
import { FiPlus } from "react-icons/fi";
import AllocationRuleTable from "@features/admin/finance/allocation-rule/components/AllocationRuleTable";
import CreateAllocationRuleModal from "@features/admin/finance/allocation-rule/components/CreateAllocationRuleModal";
import RequirePermission from '@core/components/RequirePermission';
import { ACTION_CODES } from '@features/entity/types/actionCodes';
import { useScopeId } from '@core/hooks/useRouteParamId';

const ManageFinanceAllocationRules: React.FC = () => {
    const sid = useScopeId() ?? 0;
    const [showCreate, setShowCreate] = useState(false);
    const [refreshSignal, setRefreshSignal] = useState(0);

    return (
        <Container fluid className="py-4" data-testid="manage-allocation-rules-container">
            <div
                className="d-flex flex-column flex-md-row justify-content-md-between align-items-md-center gap-3 mb-4"
                data-testid="manage-allocation-rules-header-row"
            >
                <div className="ntcog-page-title-block mb-0">
                    <h1 className="ntcog-page-heading mb-1" data-testid="manage-allocation-rules-title">
                        Finance Allocation Rules
                    </h1>
                    <p className="text-muted mb-0" data-testid="manage-allocation-rules-description">
                        Manage how income is allocated across ministers, head office, and districts
                    </p>
                </div>
                {Number.isFinite(sid) && sid > 0 && (
                    <RequirePermission mode="section" action={ACTION_CODES.CREATE_FINANCE_ALLOCATION_RULE} scopeType="NATION" scopeId={sid}>
                        <Button
                            variant="primary"
                            onClick={() => setShowCreate(true)}
                            aria-label="Add Allocation Rule"
                            data-testid="add-allocation-rule-button"
                        >
                            <FiPlus className="me-2" />
                            New Rule
                        </Button>
                    </RequirePermission>
                )}
            </div>

            <AllocationRuleTable showPagination={true} refreshSignal={refreshSignal} />

            <CreateAllocationRuleModal
                show={showCreate}
                onHide={() => setShowCreate(false)}
                onChanged={() => setRefreshSignal((s) => s + 1)}
            />
        </Container>
    );
};

export default ManageFinanceAllocationRules;
